import { OpenAPI } from './api-client';
import config from './config/appConfig';
import { authService } from './services/authService';

// Инициализация API с правильным URL и заголовками аутентификации
export const initializeApi = () => {
  OpenAPI.BASE = config.apiUrl;

  // Также можно установить другие настройки, если необходимо
  OpenAPI.WITH_CREDENTIALS = config.environment !== 'production';

  // Устанавливаем заголовки аутентификации, если пользователь уже авторизован
  authService.setAuthHeaders();
};

export default initializeApi;
